export type WebSocketDataType =
    | WebSocketUpdateResponse
    | ChatMessage
    | ChatMessage[]
    | TypingResponse
    | SyncData
    | CrazyApproval
    | CrazyTransfer
    | CrazyHolder
    | UpdateType[]
    | string
    | number // for prices
    | undefined // for messages like "ping"/"pong"

export interface WebSocketMessage<T extends WebSocketDataType = WebSocketDataType> {
    type: string
    data: T
    signature?: string
    account?: string
}

export interface WebSocketUpdateResponse {
    updates: UpdateSpecific[]
}

export enum UpdateType {
    TOKEN = 'TOKEN',
    VOTES = 'VOTES',
    CLAIMS = 'CLAIMS',
    ADMIN = 'ADMIN',
    MARKETS = 'MARKETS',
    PROPOSALS = 'PROPOSALS',
    AUCTIONS = 'AUCTIONS',
    PORTFOLIO = 'PORTFOLIO',
    ART = 'ART',
}

export enum UpdateSpecificType {
    TRANSACTION_USER = 'TRANSACTION_USER',
    TRANSACTION_TOKEN = 'TRANSACTION_TOKEN',
    ART = 'ART',
}

export interface UpdateSpecific {
    type: UpdateSpecificType
    id: number | string
}

export interface SpecificUpdate {
    updates: UpdateSpecific[]
}

export interface ChatMessage {
    id: number
    text: string
    name: string
    messageId: string
    timestamp: number
    socketId: string | null
    tags: string[]
}

export interface TypingResponse {
    userId: string
    userName: string
    isTyping: boolean
}

export interface SyncData {
    reserve0: string
    reserve1: string
}

export interface CrazyApproval {
    owner: string
    spender: string
    value: string
}

export interface CrazyTransfer {
    from: string
    to: string
    value: string
}

export interface CrazyHolder {
    address: string
    balance: string
}

// Make MessageHandler generic to handle different data types
export type MessageHandler<T extends WebSocketDataType = WebSocketDataType> = (data: T) => void
